import { defaultAllSelection } from "services/constants/selections";
import { selectLoginCompany } from "services/utils/loginAccess";
import { resolveRouteContext } from "services/utils/initialRouteAccess";
import React, { useEffect, useLayoutEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import { styled } from "@mui/material/styles";
import { pathAndProducts, pathAndProductsScreen } from "services/constants";
import moment from "moment";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  setAttendanceCompanyId,
  setAttendanceCompanyName,
  setAttendanceShiftName,
  setAttendanceShiftId,
  setAttendanceDate,
} from "services/Redux/TeamZone";
import MuiDrawer from "@mui/material/Drawer";
import * as Mui from "@mui/material";
import {
  Collapse,
  Box,
  List,
  CssBaseline,
  IconButton,
  ListItemButton,
  InputBase,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { themes } from "services/constants";
import { Typography } from "@mui/material";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  isSectionRowAccessible as isSectionRowAccessibleFor,
  isSubmenuAccessible,
  CONFIG_GATED_FLYOUT_ITEMS,
} from "./sidebarAccess";
import { GlobalSearch } from "components/GlobalSearch";
import {
  setCurrentScreen,
  setSubMenuExpand,
} from "services/Redux/userManagament";
import {
  setEditProject,
  setProjectStatus,
  setReloadHRMSApi,
} from "services/Redux/leaveManagement";
import {
  setShowShiftBack,
  setAdminShiftLocation,
} from "services/Redux/TeamZone";
import { setFilterApi } from "services/Redux/userManagament";
import { setCurrentLocation } from "services/Redux/userToken";
import { useHistory, useLocation } from "react-router-dom";
import {
  setTopbarCompanyId,
  setTopbarCompanyName,
  setScreenAccess,
  setProductAccess,
  setVisible,
} from "services/Redux/userToken";
import { hydratePayslipTemplate } from "services/utils/payslipTemplate";
import { productAccessDecision } from "components/ProductAccessGate";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { ACCESS_CHANGED_EVENT, OPEN_COMPANY_PICKER_EVENT, canUseCompanyContext, routeModuleName, createProvisioningCache, loadCachedProvisioning, productRequestOrder, provisioningCacheKey, provisioningModule, provisioningRequestOrder } from "services/utils/companyAccess";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
// The file version: it supports the open/inputRef/adornment/option props
// the company picker uses (the copy in CustomComponents/index.js does not).
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { UserSidePeek } from "./UserSidePeek";
import {
  getCachedPayInputConfig,
  requestPayInputConfig,
} from "pages/PayRoll/Configuration/PayInputConfiguration/payInputConfigApi";
import {
  PAYROLL_SETTINGS_MENU,
  PAYROLL_HOME_PATH,
  PAYROLL_SETTINGS_OVERVIEW,
  findActiveSettingsGroup,
  isPayrollSettingsPath,
  isSettingsItemActive,
  settingsItemHref,
} from "pages/PayRoll/Configuration/payrollSettingsMenu";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BoltIcon from "@mui/icons-material/Bolt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import NotificationBell from "components/NotificationBell/NotificationBell";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  designColors,
  designFontFamily,
  designRadii,
  designWeights,
  SIDEBAR_PANEL_MAX_WIDTH,
  SIDEBAR_PANEL_MIN_WIDTH,
  SIDEBAR_PANEL_WIDTH,
  SIDEBAR_PANEL_WIDTH_VAR,
  SIDEBAR_RAIL_WIDTH,
  navPanelRowSx as panelRowSx,
  navPanelTextSx as panelTextSx,
  navPanelIconSx as panelIconSx,
  navChevronSx as sectionChevronSx,
  navGuideListSx as guideListSx,
  APP_BAR_HEIGHT,
  NAV_COLORS,
} from "services/constants/designTokens";

// Slack layout: rail always visible, section panel beside it when open.
const drawerWidth = `calc(${SIDEBAR_RAIL_WIDTH}px + ${SIDEBAR_PANEL_WIDTH_VAR})`;
// Remembered panel width (per browser).
const PANEL_WIDTH_STORAGE_KEY = "sidebarPanelWidth";

// Icon before each group heading inside a section (My Requests, Approvals):
// filled and in the same grey as the section icons (Home, Approvals …).
// Headings without an entry show the label only.
const GROUP_LABEL_ICONS = {
  "Leave & time off": EventAvailableIcon,
  "Attendance & workday": ScheduleIcon,
  "Additional work": BoltIcon,
  Finance: AccountBalanceWalletIcon,
};

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: SIDEBAR_RAIL_WIDTH,
});
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: open ? drawerWidth : SIDEBAR_RAIL_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
      // Explicit, matching RequestNavRail.js's own explicit
      // designColors.white — previously unset here, relying on MUI's
      // default background.paper instead of the same shared value both
      // sidebars should read from.
      backgroundColor: designColors.white,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
      backgroundColor: designColors.white,
    },
  }),
}));

// Slack-style product rail in our primary button colours (the same teal
// gradient as designShell.primaryButtonBase) instead of Slack's purple.
const RAIL_COLORS = {
  top: designColors.tealDark,
  background: `linear-gradient(180deg, ${designColors.tealDark} 0%, ${designColors.teal} 100%)`,
  text: "rgba(255, 255, 255, 0.85)",
  textActive: "#FFFFFF",
  tileHover: "rgba(255, 255, 255, 0.14)",
  tileSelected: "#FFFFFF",
  tileSelectedShadow: "0 1px 3px rgba(15, 23, 42, 0.18)",
  selectedText: designColors.tealDark,
  divider: "rgba(255, 255, 255, 0.18)",
  scrollThumb: "rgba(255, 255, 255, 0.3)",
  scrollThumbHover: "rgba(255, 255, 255, 0.5)",
};

// Slack-style scrollbar: thin, invisible at rest, shown while the pointer
// is over the list. Keyboard focus shows it too, but a mouse click on a
// row does not keep it showing (Slack hides it once the pointer leaves).
const slackScrollbarSx = (thumbColor, thumbHoverColor) => ({
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
  "&:hover, &:has(:focus-visible)": {
    scrollbarColor: `${thumbColor} transparent`,
  },
  "&::-webkit-scrollbar": { width: 8, height: 8 },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
    borderRadius: 8,
    border: "2px solid transparent",
    backgroundClip: "content-box",
  },
  "&:hover::-webkit-scrollbar-thumb, &:has(:focus-visible)::-webkit-scrollbar-thumb": {
    backgroundColor: thumbColor,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: thumbHoverColor,
  },
});

const basePathOf = (path) => (path || "").split("?")[0];
const sectionKey = (productName, submenuName) => `${productName}::${submenuName}`;

// The section (a row with child rows) that holds the page at `pathname`.
const findOwningSectionKey = (routes, pathname) => {
  for (const route of routes || []) {
    for (const submenu of route?.collapse || []) {
      const owns = (submenu?.collapse || []).some((nested) => {
        const base = basePathOf(nested?.path);
        return Boolean(base) && (pathname === base || pathname.startsWith(`${base}/`));
      });
      if (owns) return sectionKey(route.name, submenu.name);
    }
  }
  return null;
};

// Whether a section's child row is the page on screen. Rows with their own
// path (e.g. Payroll > Reports > Statutory Reports) match on the path,
// including its child pages; rows sharing the section's page (Approvals,
// My Requests) match on ?view= / ?tab=.
const isNestedRowActive = (nested, submenu, location) => {
  const currentParams = new URLSearchParams(location.search);
  const currentView = (
    currentParams.get("view") ||
    currentParams.get("section") ||
    ""
  ).toLowerCase();
  const currentTab = (currentParams.get("tab") || "").toLowerCase();
  const queryIndex = nested.path?.indexOf("?") ?? -1;
  const nestedParams = new URLSearchParams(
    queryIndex >= 0 ? nested.path.slice(queryIndex) : "",
  );
  const nestedView = (nestedParams.get("view") || "").toLowerCase();
  const nestedTab = (nestedParams.get("tab") || "").toLowerCase();
  const routeUsesTab = Boolean(currentTab || nestedTab);
  const nestedBasePath = basePathOf(nested.path);
  const hasOwnPath =
    Boolean(nestedBasePath) && nestedBasePath !== basePathOf(submenu?.path);
  const isOnNestedPage =
    Boolean(nestedBasePath) && location.pathname === nestedBasePath;
  // Rows that pick an item on a shared page (Configuration > Statutory >
  // PF / ESI, ?item=) match on the item only; ?tab= is that page's own tab.
  const nestedItem = nestedParams.get("item");
  if (nestedItem && !hasOwnPath) {
    return isOnNestedPage && currentParams.get("item") === nestedItem;
  }
  return hasOwnPath
    ? isOnNestedPage || location.pathname.startsWith(`${nestedBasePath}/`)
    : isOnNestedPage &&
        currentView === nestedView &&
        (!routeUsesTab || currentTab === nestedTab);
};

export const Sidebar = ({ routes, toggleSidenav, setOpen, open }) => {
  const { subMenuExpand } = useSelector(
    (state) => state.userReducer,
  );
  const {
    topbarCompanyId,
    topbarCompanyName,
    userScreenAccess,
    productAccess,
    companyList,
    companyDetails,
  } = useSelector((state) => state.tokenReducer);

  // Sourced from redux (kept in sync on login and on every company save) so
  // this re-renders live -- reading straight from localStorage here used to
  // leave this stuck on whatever was cached at last login until a hard
  // refresh, even after a logo upload succeeded elsewhere on the page.
  let primaryCompany = (companyDetails ?? []).filter((data) => data?.isprimary);
  const { token, domain, currentLocation, userDetails } =
    useSelector((state) => state.tokenReducer);
  const location = useLocation();
  // Administration > Companies, Sites, Roles & User Group, Notification Settings,
  // System Configuration and Monitoring are not scoped to a single company
  // (roles and product configuration are schema-wide, and neither they nor
  // the Monitoring screens send a company_id), so the top bar's company
  // selector is hidden there.
  const isCompaniesScreen = [
    "/admin/administration/companies",
    "/admin/administration/sites",
    "/admin/administration/role/usergroup",
    "/admin/administration/notification-settings",
    "/admin/support/admin",
    "/admin/monitoring",
  ].some((path) => location.pathname.startsWith(path)) && canUseCompanyContext(topbarCompanyId, userDetails?.type, companyList);
  let firstLetter = userDetails?.first_name?.charAt(0).toUpperCase();
  // The current company has no access to the workspace on screen (same
  // decision ProductAccessGate uses): the picker shows a warning on it.
  const routeProductName = pathAndProducts.find(
    (item) => item.pathname === location.pathname.split("/")[2],
  )?.productname;
  const workspaceUnavailable =
    Boolean(routeProductName) &&
    productAccessDecision(
      productAccess,
      userScreenAccess,
      topbarCompanyId,
      routeProductName,
      userDetails?.type,
      companyList,
      routeModuleName(routes, location.pathname, routeProductName),
    ) === "denied";
  // "Select Company" in the workspace-unavailable dialog opens the picker.
  const companyPickerInputRef = useRef(null);
  const [companyPickerOpen, setCompanyPickerOpen] = useState(false);
  useEffect(() => {
    const openPicker = () => {
      setCompanyPickerOpen(true);
      // Focused so clicking elsewhere closes it, as a normal open does.
      setTimeout(() => companyPickerInputRef.current?.focus(), 0);
    };
    window.addEventListener(OPEN_COMPANY_PICKER_EVENT, openPicker);
    return () => window.removeEventListener(OPEN_COMPANY_PICKER_EVENT, openPicker);
  }, []);
  // Slack-style resizable section panel: drag its right edge, double-click
  // it to reset, or use the arrow keys on it. The width lives in a CSS
  // variable on <html> (read by the drawer, the top bar and Admin.js), so
  // dragging doesn't re-render the app; it is remembered in this browser.
  const panelWidthRef = useRef(SIDEBAR_PANEL_WIDTH);
  const [resizingPanel, setResizingPanel] = useState(false);
  const applyPanelWidth = useCallback((width) => {
    const clamped = Math.round(
      Math.min(SIDEBAR_PANEL_MAX_WIDTH, Math.max(SIDEBAR_PANEL_MIN_WIDTH, width)),
    );
    panelWidthRef.current = clamped;
    document.documentElement.style.setProperty(
      "--sidebar-panel-width",
      `${clamped}px`,
    );
  }, []);
  const savePanelWidth = useCallback(() => {
    try {
      localStorage.setItem(PANEL_WIDTH_STORAGE_KEY, String(panelWidthRef.current));
    } catch {
      // Storage blocked: the width just isn't remembered.
    }
  }, []);
  useLayoutEffect(() => {
    let saved = NaN;
    try {
      // Number(null) is 0, so a missing value falls to the default below.
      saved = Number(localStorage.getItem(PANEL_WIDTH_STORAGE_KEY));
    } catch {
      saved = NaN;
    }
    applyPanelWidth(Number.isFinite(saved) && saved > 0 ? saved : SIDEBAR_PANEL_WIDTH);
  }, [applyPanelWidth]);
  const startPanelResize = useCallback(
    (event) => {
      if (event.button !== 0) return;
      event.preventDefault();
      const startX = event.clientX;
      const startWidth = panelWidthRef.current;
      const { body } = document;
      const previousCursor = body.style.cursor;
      const previousUserSelect = body.style.userSelect;
      body.style.cursor = "ew-resize";
      body.style.userSelect = "none";
      setResizingPanel(true);
      const onMove = (moveEvent) =>
        applyPanelWidth(startWidth + moveEvent.clientX - startX);
      const onUp = () => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
        body.style.cursor = previousCursor;
        body.style.userSelect = previousUserSelect;
        setResizingPanel(false);
        savePanelWidth();
      };
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onUp);
    },
    [applyPanelWidth, savePanelWidth],
  );
  const handlePanelResizeKey = (event) => {
    const step = event.shiftKey ? 48 : 16;
    const current = panelWidthRef.current;
    const next = {
      ArrowLeft: current - step,
      ArrowRight: current + step,
      Home: SIDEBAR_PANEL_MIN_WIDTH,
      End: SIDEBAR_PANEL_MAX_WIDTH,
    }[event.key];
    if (next === undefined) return;
    event.preventDefault();
    applyPanelWidth(next);
    savePanelWidth();
  };
  const resetPanelWidth = () => {
    applyPanelWidth(SIDEBAR_PANEL_WIDTH);
    savePanelWidth();
  };
  const [openSidePeek, setOpenSidePeek] = useState(false);
  const [updateProfileSidePeek, setUpdateProfileSidePeek] = useState(false);
  // Notification panel and the profile side peek are both fixed-position
  // overlays anchored to this same AppBar — opening one while the other is
  // already open used to stack them on top of each other instead of
  // swapping. Tracked here (not inside NotificationBell) so this component,
  // the only place that opens either panel, can enforce "only one at a time".
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);
  // Navigating anywhere — switching workspace modules (Team Workspace -> Payroll)
  // or just switching sub-pages within the same module (Team Workspace > Home ->
  // Team Workspace > Approvals) — used to leave whichever side panel was open
  // (notifications or the profile side peek) pinned on top of the
  // newly-loaded screen, since neither panel's open state was tied to
  // navigation. currentLocation alone only tracks the top-level module, so a
  // same-module route change (handleSubMenu's history.push) never fired this;
  // location.pathname catches that too, alongside every other way
  // currentLocation itself can change (handleItemClick, etc.).
  useEffect(() => {
    setOpenSidePeek(false);
    setNotificationPanelOpen(false);
  }, [currentLocation, location.pathname]);
  const history = useHistory();
  const dispatch = useDispatch();
  const provisioningRequests = useRef(provisioningRequestOrder);
  const productRequests = useRef(productRequestOrder);
  const provisioningCache = useRef(createProvisioningCache());
  const provisioningInFlight = useRef(new Map());
  const currentAccessRef = useRef(userScreenAccess);
  currentAccessRef.current = userScreenAccess;
  const routesRef = useRef(routes);
  routesRef.current = routes;
  const [currentRoute, setCurrentRoute] = React.useState(routes[0]);

  // Slack-style sections: a row with its own child rows (Approvals, Salary,
  // Configuration, ...) folds open inside the panel instead of opening a
  // pop-out. Only one is open at a time (opening one closes the other, and
  // clicking the open one closes it). Going to a page opens the section that
  // holds it and closes any other; a page outside every section (Home,
  // Attendance, ...) closes them all.
  const [openSections, setOpenSections] = useState(() => {
    const key = findOwningSectionKey(routes, location.pathname);
    return key ? { [key]: true } : {};
  });
  useEffect(() => {
    const key = findOwningSectionKey(routesRef.current, location.pathname);
    setOpenSections((prev) =>
      key
        ? prev[key] && Object.keys(prev).length === 1
          ? prev
          : { [key]: true }
        : Object.keys(prev).length === 0
          ? prev
          : {},
    );
  }, [location.pathname]);
  // The menu stops at the page: product > section > page. Anything below a
  // page is tabs or a panel inside the page, never a third sidebar level.
  const toggleSection = useCallback((key) => {
    setOpenSections((prev) => (prev[key] ? {} : { [key]: true }));
  }, []);

  // Payroll Settings: on its pages the Payroll menu is swapped for the
  // settings menu in the same column ("‹ Payroll" swaps it back and keeps
  // the page open). Groups fold like any other section, one open at a time;
  // the group holding the page opens on its own.
  const onPayrollSettingsPath = isPayrollSettingsPath(location.pathname);
  const [payrollSettingsMenu, setPayrollSettingsMenu] = useState(onPayrollSettingsPath);
  useEffect(() => {
    setPayrollSettingsMenu(isPayrollSettingsPath(location.pathname));
  }, [location.pathname]);
  const activeSettingsGroup = onPayrollSettingsPath
    ? findActiveSettingsGroup(location)
    : null;
  const [openSettingsGroup, setOpenSettingsGroup] = useState(activeSettingsGroup);
  // Follow the page on screen: a settings page opens its group, Overview
  // (no group) folds them all. The sidebar stays mounted between pages, so
  // without the reset the last group opened (e.g. Statutory) stayed open
  // on Overview.
  useEffect(() => {
    setOpenSettingsGroup(activeSettingsGroup);
  }, [activeSettingsGroup, location.pathname]);
  const [settingsQuery, setSettingsQuery] = useState("");
  const goToSetting = useCallback(
    (item) => {
      const href = settingsItemHref(item);
      if (`${location.pathname}${location.search}` !== href) history.push(href);
      dispatch(setGlobalSearchValue(""));
      if (window.innerWidth < 1400) setOpen(false);
    },
    [dispatch, history, location.pathname, location.search, setOpen],
  );
  const orderedRoutes = [...routes].sort(
    (a, b) => (a.sidebarOrder ?? 999) - (b.sidebarOrder ?? 999),
  );
  // The product whose sections fill the panel: the one on screen.
  const currentProduct = orderedRoutes.find(
    (item) =>
      !item.sectionLabel &&
      !item.hideInSidebar &&
      item.name === currentLocation,
  );
  const showPayrollSettingsMenu =
    payrollSettingsMenu && currentProduct?.name === "Payroll";

  // Section rows hidden because Payroll > Configuration > Pay Input turns
  // that pay input off. Read from the shared config cache, so the row is
  // already right when the section opens (no flash). The settings load in
  // advance for the selected company and again each time a section opens,
  // since they can change at any time. Settings that can't be loaded leave
  // the row visible.
  const [, setConfigVersion] = useState(0);
  const configCompanyValid =
    Number(topbarCompanyId) > 0 && Number(topbarCompanyId) !== defaultAllSelection;
  const isConfigDisabledPath = (path) => {
    if (!configCompanyValid || !domain) return false;
    const gated = CONFIG_GATED_FLYOUT_ITEMS.find((item) => item.path === path);
    return gated
      ? getCachedPayInputConfig(domain, topbarCompanyId, gated.payInputType)?.enabled === false
      : false;
  };
  // Only users whose menu has the row (Payroll access) load its settings.
  const findRoutePath = (list, path) =>
    (list || []).some((entry) => entry?.path === path || findRoutePath(entry?.collapse, path));
  const gatedPathsKey = CONFIG_GATED_FLYOUT_ITEMS
    .filter((item) => findRoutePath(routes, item.path))
    .map((item) => item.path)
    .join(",");
  // Refresh when the company changes and when a section holding the row opens.
  const configRefreshKey = (currentProduct?.collapse || [])
    .filter(
      (submenu) =>
        openSections[sectionKey(currentProduct.name, submenu.name)] &&
        (submenu.collapse || []).some((nested) =>
          CONFIG_GATED_FLYOUT_ITEMS.some((item) => item.path === nested.path),
        ),
    )
    .map((submenu) => submenu.name)
    .join(",");
  useEffect(() => {
    if (!configCompanyValid || !domain || !gatedPathsKey) return undefined;
    const controller = new AbortController();
    CONFIG_GATED_FLYOUT_ITEMS.filter((item) => gatedPathsKey.split(",").includes(item.path)).forEach(({ payInputType, request }) => {
      const before = getCachedPayInputConfig(domain, topbarCompanyId, payInputType)?.enabled;
      (request || requestPayInputConfig)({ domain, companyId: topbarCompanyId, payInputType, signal: controller.signal })
        .then(({ config }) => {
          if (!controller.signal.aborted && config.enabled !== before) setConfigVersion((n) => n + 1);
        })
        .catch(() => {});
    });
    return () => controller.abort();
  }, [configRefreshKey, domain, topbarCompanyId, configCompanyValid, gatedPathsKey]);
  const normalizedCompanyList = Array.isArray(companyList)
    ? companyList
    : (() => {
        try {
          return JSON.parse(companyList || "[]");
        } catch {
          return [];
        }
      })();
  const isAllCompaniesOption = useCallback(
    (company) =>
      String(company?.company_id) === String(defaultAllSelection) ||
      company?.company_name === "All" ||
      company?.company_name === "All Companies",
    [],
  );
  const activeCompanyList = normalizedCompanyList.filter(
    (obj) => isAllCompaniesOption(obj) || obj?.isactive !== false,
  );
  // The topbar never offers "All Companies": every screen works on one
  // company at a time. A user still on "All" is moved to their first real
  // company by updatePrimaryCompany below.
  const selectableCompanies = activeCompanyList.filter(
    (obj) =>
      canUseCompanyContext(obj.company_id, userDetails?.type, activeCompanyList) &&
      !isAllCompaniesOption(obj),
  );
  // Teal/slate design system rollout: Administration got it first, Team Workspace
  // second, then My Workspace — each location opts into the same shared sidebar
  // selection styling (active teal header, rounded rows, white active text,
  // slate-gray submenu rows) driven from designTokens.js. Payroll and People
  // already ship the modernized page content itself (Save View, designColors
  // tokens throughout their screens — see PayRoll/Configuration/PayrollConfiguration, HR/Shift,
  // PayRoll/Salary, etc.), so their sidebar rows were the one place
  // still stuck on the old flat-black/mint-green look. Projects is added here
  // for sidebar-row consistency with every other module — note its page
  // content (pages/Projects/**) hasn't been migrated to designColors/
  // designTokens or Save View yet, unlike Payroll/People, so only the
  // sidebar row itself is modernized for now. Extend this condition as more
  // locations adopt the same look.
  const isDesignSystemLocation =
    currentLocation === "Monitoring" ||
    currentLocation === "Administration" ||
    currentLocation === "Team Workspace" ||
    currentLocation === "My Workspace" ||
    currentLocation === "System Configuration" ||
    currentLocation === "Payroll" ||
    currentLocation === "People" ||
    currentLocation === "Projects" ||
    currentLocation === "CRM" ||
    currentLocation === "Operations";

  useEffect(() => {
    // Only a real width change collapses the sidebar. Mobile browsers fire
    // `resize` for height-only changes too (address bar sliding away on
    // scroll, on-screen keyboard opening), which used to snap a sidebar the
    // user had just expanded straight back to collapsed.
    let lastWidth = window.innerWidth;
    const handleResize = () => {
      const width = window.innerWidth;
      if (width === lastWidth) return;
      const wasNarrow = lastWidth < 1400;
      lastWidth = width;
      if (width < 1400) {
        setOpen(false);
        document.body.classList.remove("g-sidenav-pinned");
        document.body.classList.add("g-sidenav-hidden");
      } else if (wasNarrow) {
        // Crossing back up to desktop width (mobile view -> desktop view)
        // re-expands the sidebar. Only on the crossing itself, so a desktop
        // user who collapsed it by hand isn't re-expanded on every resize.
        setOpen(true);
        document.body.classList.add("g-sidenav-pinned");
        document.body.classList.remove("g-sidenav-hidden");
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setOpen]);

  const handleDrawerOpen = () => {
    toggleSidenav();
  };

  const attendanceScreenConfigurations = useCallback(() => {
    dispatch(setAttendanceCompanyId(topbarCompanyId));
    dispatch(setAttendanceCompanyName(topbarCompanyName || ""));
    if (topbarCompanyId) localStorage.setItem("attendanceCompanyId", topbarCompanyId);
    else localStorage.removeItem("attendanceCompanyId");
    localStorage.setItem("attendanceCompanyName", topbarCompanyName || "");
    dispatch(setAttendanceShiftId(defaultAllSelection));
    dispatch(setAttendanceShiftName("All"));
    localStorage.setItem("attendanceShiftId", defaultAllSelection);
    localStorage.setItem("attendanceShiftName", "All");
    dispatch(setAttendanceDate(moment(new Date()).format("YYYY-MM-DD")));
    localStorage.setItem(
      "attendanceDate",
      moment(new Date()).format("YYYY-MM-DD"),
    );
  }, [dispatch, topbarCompanyId, topbarCompanyName]);

  const getAccessDetails = useCallback(
    async (topbarCompany, module, options = {}) => {
      if (!topbarCompany || !userDetails?.id) return;
      if (!canUseCompanyContext(topbarCompany, userDetails?.type, normalizedCompanyList)) {
        provisioningRequests.current.start();
        dispatch(setScreenAccess({ product_name: module, company_id: topbarCompany, module_details: [] }));
        return;
      }
      const cacheKey = provisioningCacheKey(domain, userDetails.id, topbarCompany, module);
      localStorage.removeItem("screenAccess");
      await loadCachedProvisioning({
        cache: provisioningCache.current,
        inFlight: provisioningInFlight.current,
        requests: provisioningRequests.current,
        cacheKey,
        companyId: topbarCompany,
        productName: module,
        currentAccess: currentAccessRef.current,
        force: options.force,
        background: options.background,
        load: () => customGetAPI(
          `${domain}product/access/provisioning/?company_id=${topbarCompany}&module=${encodeURIComponent(provisioningModule(topbarCompany, module))}`,
        ),
        apply: (access) => dispatch(setScreenAccess(access)),
      });
    },
    [dispatch, domain, userDetails?.id, userDetails?.type, normalizedCompanyList],
  );

  // A topbar company switch always reloads provisioning from the API instead
  // of serving the 5-minute cache, so permissions changed in the meantime
  // show up right away. Runs before the effect below that requests it.
  const lastTopbarCompanyRef = useRef(topbarCompanyId);
  useEffect(() => {
    if (String(lastTopbarCompanyRef.current) === String(topbarCompanyId)) return;
    lastTopbarCompanyRef.current = topbarCompanyId;
    provisioningCache.current.clear();
    provisioningInFlight.current.clear();
  }, [topbarCompanyId]);

  useEffect(() => {
    const parts = location.pathname.split("/");
    const match = pathAndProducts.find((item) => item.pathname === parts[2]);
    if (match?.productname && userDetails?.id && topbarCompanyId &&
      Array.isArray(productAccess) && productAccess.some((product) => product.product_name === match.productname)) {
      dispatch(setCurrentLocation(match.productname));
      const context = resolveRouteContext(routesRef.current, location.pathname);
      localStorage.setItem("currentScreen", match.productname);
      if (context) {
        localStorage.setItem("currentSubMenu", context.screenName);
        dispatch(setCurrentScreen(context.screenName));
      }
      dispatch(setVisible(match.productname === "CRM"));
      getAccessDetails(topbarCompanyId, match.productname);
    }
  }, [
    dispatch,
    getAccessDetails,
    location.pathname,
    topbarCompanyId,
    productAccess,
    userDetails?.id,
  ]);

  const getAvailableProducts = useCallback(async (topbarCompany, options = {}) => {
    const request = productRequests.current.start();
    if (!options.background) dispatch(setProductAccess(null));
    localStorage.removeItem("productAccess");
    if (!topbarCompany || !userDetails?.id) return;
    const response = await customGetAPIWithToken(
      `${domain}login/available/products/?company_id=${topbarCompany}`,
      token,
    );
    if (!productRequests.current.isCurrent(request)) return;
    const products = response?.ok && Array.isArray(response.responseDetails) ? response.responseDetails : [];
    dispatch(setProductAccess({ products, company_id: topbarCompany }));
    localStorage.setItem("productAccess", JSON.stringify(products));
  }, [dispatch, domain, token, userDetails?.id]);

  useEffect(() => {
    getAvailableProducts(topbarCompanyId);
  }, [getAvailableProducts, topbarCompanyId]);

  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      getAccessDetails(topbarCompanyId, currentLocation, { background: true });
    };
    const refreshAfterChange = () => {
      provisioningCache.current.clear();
      provisioningInFlight.current.clear();
      getAccessDetails(topbarCompanyId, currentLocation, { background: true, force: true });
      getAvailableProducts(topbarCompanyId, { background: true });
    };
    window.addEventListener(ACCESS_CHANGED_EVENT, refreshAfterChange);
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener(ACCESS_CHANGED_EVENT, refreshAfterChange);
      window.removeEventListener("focus", refresh);
    };
  }, [currentLocation, getAccessDetails, getAvailableProducts, topbarCompanyId]);

  useEffect(() => () => {
    provisioningRequests.current.start();
    productRequests.current.start();
  }, []);

  const updatePrimaryCompany = useCallback(() => {
    const selectedCompany = selectableCompanies.find(
      (company) => String(company?.company_id) === String(topbarCompanyId),
    );

    if (selectedCompany) {
      if (selectedCompany.company_name !== topbarCompanyName) {
        dispatch(setTopbarCompanyName(selectedCompany.company_name));
        localStorage.setItem("topbarCompanyName", selectedCompany.company_name);
      }
      return {
        companyId: selectedCompany.company_id,
        companyName: selectedCompany.company_name,
      };
    }

    if (selectableCompanies.length !== 1) {
      const firstCompany = selectLoginCompany(selectableCompanies, userDetails?.type);
      if (!firstCompany) return null;
      const fallbackCompany = {
        companyId: firstCompany.company_id,
        companyName: firstCompany.company_name,
      };

      if (
        String(topbarCompanyId) !== String(fallbackCompany.companyId) ||
        topbarCompanyName !== fallbackCompany.companyName
      ) {
        dispatch(setTopbarCompanyName(fallbackCompany.companyName));
        dispatch(setTopbarCompanyId(fallbackCompany.companyId));
        localStorage.setItem("topbarCompanyName", fallbackCompany.companyName);
        localStorage.setItem("topbarCompanyId", fallbackCompany.companyId);
      }

      return fallbackCompany;
    }

    let resolvedCompany = null;

    const primaryCompanyMatch = (companyDetails ?? []).find(
      (data) =>
        data?.isprimary &&
        data?.isactive !== false &&
        selectableCompanies.some(
          (company) => String(company?.company_id) === String(data?.id),
        ),
    );
    if (primaryCompanyMatch) {
      resolvedCompany = {
        companyId: primaryCompanyMatch.id,
        companyName: primaryCompanyMatch.companyname,
      };
    }

    if (!resolvedCompany) {
      resolvedCompany = {
        companyId: selectableCompanies[0]?.company_id,
        companyName: selectableCompanies[0]?.company_name,
      };
    }

    if (!resolvedCompany?.companyId) return null;

    dispatch(setTopbarCompanyName(resolvedCompany.companyName));
    dispatch(setTopbarCompanyId(resolvedCompany.companyId));
    hydratePayslipTemplate({
      domain,
      companyId: resolvedCompany.companyId,
      dispatch,
    });
    localStorage.setItem("topbarCompanyName", resolvedCompany.companyName);
    localStorage.setItem("topbarCompanyId", resolvedCompany.companyId);
    return resolvedCompany;
  }, [
    userDetails?.type,
    companyDetails,
    dispatch,
    domain,
    selectableCompanies,
    topbarCompanyId,
    topbarCompanyName,
  ]);

  useEffect(() => {
    updatePrimaryCompany();
  }, [updatePrimaryCompany]);

  const handleItemClick = useCallback(
    (item) => {
      // Close on every module click, not just when currentLocation actually
      // changes — the currentLocation-keyed effect above misses a re-click
      // of the module you're already on (else branch below), which should
      // still close whichever panel is open.
      setOpenSidePeek(false);
      setNotificationPanelOpen(false);
      // Picking a product shows its sections, like switching workspace in
      // Slack, even if the panel was hidden.
      if (item?.collapse && !open) toggleSidenav();
      dispatch(setGlobalSearchValue(""));
      if (item.name !== currentLocation) {
        dispatch(setCurrentLocation(item.name));
        localStorage.setItem("currentScreen", item.name);
        if (item.name === "Projects") {
          dispatch(setCurrentScreen("Projects"));
          localStorage.setItem("currentSubMenu", "Projects");
          dispatch(setVisible(false));
        } else if (item.name === "Administration") {
          dispatch(setCurrentScreen("Users"));
          localStorage.setItem("currentSubMenu", "Users");
          dispatch(setVisible(false));
        } else if (item.name === "Team Workspace") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Home"));
          localStorage.setItem("currentSubMenu", "Home");
        } else if (item.name === "Monitoring") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Dashboard"));
          localStorage.setItem("currentSubMenu", "Dashboard");
        } else if (item.name === "Settings") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen(""));
        } else if (item.name === "Invoice") {
          dispatch(setCurrentScreen(""));
          dispatch(setVisible(false));
        } else if (item.name === "My Workspace") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Status"));
          localStorage.setItem("currentSubMenu", "Status");
        } else if (item.name === "Payroll") {
          dispatch(setVisible(false));
          // Payroll opens on Salary > Salary Components; "Salary
          // Configuration" is that row's `name` in routes.js.
          dispatch(setCurrentScreen("Salary Configuration"));
          localStorage.setItem("currentSubMenu", "Salary Configuration");
        } else if (item.name === "People") {
          dispatch(setCurrentScreen("Employee"));
          localStorage.setItem("currentSubMenu", "Employee");
          dispatch(setVisible(false));
        } else if (item.name === "System Configuration") {
          dispatch(setCurrentScreen("Product Control"));
          localStorage.setItem("currentSubMenu", "Product Control");
          dispatch(setVisible(false));
        } else if (item.name === "Operations") {
          dispatch(setCurrentScreen("Work Sessions"));
          localStorage.setItem("currentSubMenu", "Work Sessions");
          dispatch(setVisible(false));
        } else if (item.name === "CRM") {
          dispatch(setVisible(true));
        }
        history.push(`${item.layout}${item.uri || item.path}`);
        dispatch(setCurrentLocation(item.name));
        setCurrentRoute(item);
        const resolvedCompany = updatePrimaryCompany();
        getAccessDetails(
          resolvedCompany?.companyId ?? topbarCompanyId,
          item.name,
        );
      } else {
        if (item.name === "Payroll") {
          const resolvedCompany = updatePrimaryCompany();
          getAccessDetails(
            resolvedCompany?.companyId ?? topbarCompanyId,
            item.name,
          );
        }
      }
    },
    [
      currentLocation,
      dispatch,
      getAccessDetails,
      history,
      open,
      toggleSidenav,
      topbarCompanyId,
      updatePrimaryCompany,
    ],
  );

  const handleNestedNavigation = useCallback(
    (menuItem) => {
      if (menuItem.name === "Tasks") {
        dispatch(setEditProject(null));
        dispatch(
          setProjectStatus([
            "ToDo",
            "InProgress",
            "Review",
            "Testing",
            "Completed",
          ]),
        );
        dispatch(setReloadHRMSApi(true));
      }
      if (menuItem.name === "Shift") {
        dispatch(setShowShiftBack(false));
        dispatch(setFilterApi(true));
        dispatch(setAdminShiftLocation("Shift"));
      }
      if (
        menuItem.name === "Work Sessions" ||
        menuItem.name === "Settings" ||
        menuItem.name === "Check-In Policy" ||
        menuItem.name === "Geo Fenced Sites"
      ) {
        dispatch(setFilterApi(true));
      }
      if (
        menuItem.name === "Earnings" ||
        menuItem.name === "Payroll Processing" ||
        menuItem.name === "Deductions" ||
        menuItem.name === "EOD Report" ||
        menuItem.name === "Daily Report" ||
        menuItem.name === "Daily Reports" ||
        menuItem.name === "Incentive"
      ) {
        dispatch(setFilterApi(true));
      }

      if (menuItem.name === "Attendance") {
        attendanceScreenConfigurations();
      }

      history.push(menuItem.path);
      dispatch(setGlobalSearchValue(""));
      dispatch(setCurrentScreen(menuItem.name));
      localStorage.setItem("currentSubMenu", menuItem.name);
      if (window.innerWidth < 1400) {
        setOpen(false);
      }
    },
    [attendanceScreenConfigurations, dispatch, history, setOpen],
  );

  // A top-bar search result opens like its sidebar row would (same
  // per-screen setup); anything else (settings, actions, employees) just
  // goes to its route.
  const openSearchResult = useCallback(
    (entry) => {
      const findRow = (list) => {
        for (const row of list || []) {
          if (row?.path === entry.route && !row?.collapse?.length) return row;
          const found = findRow(row?.collapse);
          if (found) return found;
        }
        return null;
      };
      const row = findRow(routesRef.current.flatMap((product) => product?.collapse || []));
      if (row) {
        handleNestedNavigation(row);
        return;
      }
      history.push(entry.route);
      dispatch(setGlobalSearchValue(""));
      if (window.innerWidth < 1400) setOpen(false);
    },
    [dispatch, handleNestedNavigation, history, setOpen],
  );

  // Product rail (far left, always visible): one tile per product.
  // Product rail (far left, always visible), styled like Slack's: a dark
  // strip, white icons in rounded tiles with a short label below, a light
  // fill on hover and a brighter one on the product you're in.
  const renderRail = () =>
    orderedRoutes.map((item) => {
      if (item.sectionLabel || item.hideInSidebar) return null;
      const active = item.name === currentLocation;
      const ProductIcon = item.icon;
      const fullName = item.displayName || item.name;
      return (
        <React.Fragment key={item.name}>
          <Mui.Tooltip
            title={fullName}
            placement="right"
            arrow
            slotProps={tooltipStyleProps}
          >
            <Mui.ButtonBase
              onClick={() => handleItemClick(item)}
              aria-label={fullName}
              aria-current={active ? "page" : undefined}
              // Selected product: one solid white tile around icon + label,
              // teal icon, bold teal label. Others: soft white, semibold as before.
              sx={{
                width: `calc(100% - 8px)`,
                mx: "4px",
                my: 0.25,
                flexShrink: 0,
                py: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                borderRadius: "12px",
                backgroundColor: active ? RAIL_COLORS.tileSelected : "transparent",
                boxShadow: active ? RAIL_COLORS.tileSelectedShadow : "none",
                transition: "background-color 0.15s ease",
                "& .rail-icon, & .rail-label": {
                  transition: "color 0.15s ease",
                },
                "&:hover": {
                  backgroundColor: active ? RAIL_COLORS.tileSelected : RAIL_COLORS.tileHover,
                },
                "&:hover .rail-icon, &:hover .rail-label": {
                  color: active ? RAIL_COLORS.selectedText : RAIL_COLORS.textActive,
                },
                "&.Mui-focusVisible": {
                  outline: `2px solid ${RAIL_COLORS.textActive}`,
                  outlineOffset: 1,
                },
              }}
            >
              <Box
                className="rail-tile"
                sx={{
                  width: 32,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {ProductIcon ? (
                  <ProductIcon
                    className="rail-icon"
                    sx={{
                      fontSize: 20,
                      color: active ? RAIL_COLORS.selectedText : RAIL_COLORS.text,
                    }}
                  />
                ) : null}
              </Box>
              <Typography
                component="span"
                className="rail-label"
                sx={{
                  fontFamily: designFontFamily,
                  fontSize: 11,
                  lineHeight: 1.2,
                  fontWeight: active ? designWeights.heading : designWeights.semibold,
                  color: active ? RAIL_COLORS.selectedText : RAIL_COLORS.text,
                  maxWidth: SIDEBAR_RAIL_WIDTH - 12,
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {item.railLabel || fullName}
              </Typography>
            </Mui.ButtonBase>
          </Mui.Tooltip>
          {item.sidebarDividerAfter && (
            <Box
              sx={{
                width: 32,
                height: "1px",
                my: 0.5,
                flexShrink: 0,
                backgroundColor: RAIL_COLORS.divider,
              }}
            />
          )}
        </React.Fragment>
      );
    });

  // Payroll Settings menu (replaces the Payroll rows on its pages). Same
  // look as every section: Overview is a single page row, each group is a
  // section with a grey icon that folds, its pages hang from the guide line.
  // While searching, every group with a match is open.
  const renderPayrollSettingsSections = () => {
    const needle = settingsQuery.trim().toLowerCase();
    const groups = PAYROLL_SETTINGS_MENU.map((group) => ({
      ...group,
      shown: needle
        ? group.items.filter((item) =>
            `${item.label} ${group.label}`.toLowerCase().includes(needle),
          )
        : group.items,
    })).filter((group) => group.shown.length > 0);
    const overviewActive = isSettingsItemActive(PAYROLL_SETTINGS_OVERVIEW, location);
    const pageLabel = (text, sx) => (
      <Typography component="span" sx={{ ...sx, flex: "1 1 auto", minWidth: 0, whiteSpace: "normal", lineHeight: 1.35 }}>
        {text}
      </Typography>
    );

    return (
      <>
        <ListItemButton
          sx={panelRowSx({ page: overviewActive })}
          onClick={() => goToSetting(PAYROLL_SETTINGS_OVERVIEW)}
          aria-current={overviewActive ? "page" : undefined}
        >
          <GridViewRoundedIcon sx={panelIconSx({ page: overviewActive })} />
          {pageLabel(PAYROLL_SETTINGS_OVERVIEW.label, panelTextSx({ page: overviewActive }))}
        </ListItemButton>
        <Box
          sx={{
            mx: 0.75,
            my: 0.75,
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            px: 1,
            height: 34,
            border: `1px solid ${designColors.borderInput}`,
            borderRadius: designRadii.control,
            "&:focus-within": { borderColor: designColors.teal },
          }}
        >
          <SearchIcon sx={{ fontSize: 17, color: designColors.slate400 }} />
          <InputBase
            value={settingsQuery}
            onChange={(event) => setSettingsQuery(event.target.value)}
            placeholder="Search settings"
            inputProps={{ "aria-label": "Search settings" }}
            sx={{ flex: 1, fontFamily: designFontFamily, fontSize: 13, color: designColors.slate900 }}
          />
        </Box>
        {groups.map((group) => {
          const GroupIcon = group.icon;
          const expanded = Boolean(needle) || openSettingsGroup === group.key;
          const strong = expanded || activeSettingsGroup === group.key;
          return (
            <React.Fragment key={group.key}>
              <ListItemButton
                sx={panelRowSx({})}
                onClick={() =>
                  !needle && setOpenSettingsGroup(expanded ? null : group.key)
                }
                aria-expanded={expanded}
              >
                <GroupIcon sx={panelIconSx({ strong })} />
                {pageLabel(group.label, panelTextSx({ strong }))}
                <ExpandMoreRoundedIcon sx={sectionChevronSx(expanded)} />
              </ListItemButton>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ ...guideListSx("24px"), my: 0.25 }}>
                  {group.shown.map((item) => {
                    const page = isSettingsItemActive(item, location);
                    return (
                      <ListItemButton
                        key={item.key}
                        sx={panelRowSx({ page, depth: "nested" })}
                        onClick={() => goToSetting(item)}
                        aria-current={page ? "page" : undefined}
                      >
                        {pageLabel(item.label, panelTextSx({ page, depth: "nested" }))}
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            </React.Fragment>
          );
        })}
        {groups.length === 0 && (
          <Typography sx={{ px: 1.75, py: 1, fontFamily: designFontFamily, fontSize: 13, color: designColors.slate600 }}>
            No settings match “{settingsQuery.trim()}”.
          </Typography>
        )}
      </>
    );
  };

  // Section panel: the selected product's rows. Rows with child rows are
  // sections that fold open in place (they used to open a pop-out).
  const renderPanelSections = () => {
    if (!currentProduct) return null;
    const productName = currentProduct.name;
    const parts = location.pathname.split("/");
    const routeProduct = pathAndProducts.find(
      (item) => item.pathname === parts[2],
    )?.productname;
    const matchSubmenu = pathAndProductsScreen.find(
      (item) => item.pathname === parts[3],
    );
    const activeSubmenuName = routeProduct === "Monitoring"
      ? ({ devices: "Devices", "event-trace": "Event Trace" }[parts[3]] || "Dashboard")
      : routeProduct === "System Configuration" && parts[3] === "admin"
        ? "Product Control"
      : routeProduct === "System Configuration" && parts[3] === "organisation"
        ? "Organisation Details"
      : matchSubmenu?.productname;

    // Same rules as the top-bar search (sidebarAccess.js).
    const submenuAccessible = (submenu) =>
      isSubmenuAccessible(productName, submenu, userScreenAccess);
    const isSectionRowAccessible = (submenu, nested) =>
      isSectionRowAccessibleFor(submenu, nested, userScreenAccess);

    const rowLabel = (text, textSx) => (
      <Mui.Tooltip
        title={text}
        placement="right"
        arrow
        enterDelay={700}
        slotProps={tooltipStyleProps}
      >
        <Typography
          component="span"
          noWrap
          sx={{ ...textSx, flex: "1 1 auto", minWidth: 0, color: "inherit" }}
        >
          {text}
        </Typography>
      </Mui.Tooltip>
    );

    let previousGroupLabel = null;
    return (currentProduct.collapse || [])
      .filter((submenu) => !submenu?.hideInSidebar && submenuAccessible(submenu))
      // Settings rows (sidebarFooter) go last, below a thin divider.
      .sort((a, b) => Number(!!a.sidebarFooter) - Number(!!b.sidebarFooter))
      .map((submenu, index, rows) => {
        const hasChildRows = (submenu.collapse || []).some(
          (nested) => !nested?.hideInSidebar,
        );
        const children = (submenu.collapse || []).filter(
          (nested) =>
            !nested?.hideInSidebar &&
            !isConfigDisabledPath(nested.path) &&
            isSectionRowAccessible(submenu, nested),
        );
        // Nothing left to show inside it: hide the section header too.
        if (hasChildRows && children.length === 0) return null;

        const showGroupLabel =
          !!submenu.groupLabel && submenu.groupLabel !== previousGroupLabel;
        if (submenu.groupLabel) previousGroupLabel = submenu.groupLabel;
        const groupLabelNode = showGroupLabel ? (
          <Typography
            sx={{
              px: 1.75,
              pt: 1.25,
              pb: 0.5,
              fontSize: 11,
              fontWeight: designWeights.heading,
              color: designColors.slate500,
              fontFamily: designFontFamily,
            }}
          >
            {submenu.groupLabel}
          </Typography>
        ) : null;

        const label = submenu.displayName || submenu.name;
        const SubIcon = submenu.icon;
        // Team Workspace's hidden "EOD Report" route is filed under Reports.
        const matchesRoute =
          submenu.name === activeSubmenuName ||
          (productName === "Team Workspace" &&
            submenu.name === "Reports" &&
            activeSubmenuName === "EOD Report");

        if (!hasChildRows) {
          return (
            <React.Fragment key={submenu.name}>
              {groupLabelNode}
              {submenu.sidebarFooter && !rows[index - 1]?.sidebarFooter && index > 0 && (
                <Mui.Divider
                  sx={{ my: 1, mx: 1.5, borderColor: designColors.slate200 }}
                />
              )}
              <ListItemButton
                sx={panelRowSx({ page: matchesRoute })}
                onClick={() =>
                  // Back on the Payroll menu while a settings page is open:
                  // show the settings menu again, keeping that page.
                  submenu.sidebarFooter && onPayrollSettingsPath
                    ? setPayrollSettingsMenu(true)
                    : handleNestedNavigation(submenu)
                }
                aria-current={matchesRoute ? "page" : undefined}
              >
                {SubIcon ? <SubIcon sx={panelIconSx({ page: matchesRoute })} /> : null}
                {rowLabel(label, panelTextSx({ page: matchesRoute }))}
              </ListItemButton>
            </React.Fragment>
          );
        }

        const key = sectionKey(productName, submenu.name);
        const expanded = Boolean(openSections[key]);
        const childActive = children.some((nested) =>
          isNestedRowActive(nested, submenu, location),
        );
        // A section is never green: open (or holding the current page) it
        // is bold dark text with a dark icon. Only the page row is green.
        const strong = expanded || childActive || matchesRoute;

        return (
          <React.Fragment key={submenu.name}>
            {groupLabelNode}
            <ListItemButton
              sx={panelRowSx({})}
              onClick={() => toggleSection(key)}
              aria-expanded={expanded}
            >
              {SubIcon ? <SubIcon sx={panelIconSx({ strong })} /> : null}
              {rowLabel(label, panelTextSx({ strong }))}
              <ExpandMoreRoundedIcon sx={sectionChevronSx(expanded)} />
            </ListItemButton>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{ ...guideListSx("24px"), my: 0.25 }}
              >
                {children.map((nested, nestedIndex) => {
                  const showNestedLabel =
                    !!nested.groupLabel &&
                    nested.groupLabel !== children[nestedIndex - 1]?.groupLabel;
                  // A standalone row (no groupLabel) right before the first
                  // grouped row gets a divider so it doesn't blend into it.
                  const showDividerAfter =
                    !nested.groupLabel && !!children[nestedIndex + 1]?.groupLabel;
                  const nestedActive = isNestedRowActive(nested, submenu, location);
                  return (
                    <React.Fragment key={nested.name}>
                      {showNestedLabel && (() => {
                        const GroupIcon = GROUP_LABEL_ICONS[nested.groupLabel];
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              // The icon sits on the guide line like a marker
                              // (centred on it, -8px), so the label starts at
                              // the same edge as "Approval Center" (16px).
                              gap: "7px",
                              ...(GroupIcon ? { ml: "-8px" } : { pl: 2 }),
                              pr: 2,
                              pt: nestedIndex === 0 ? 0.75 : 1.5,
                              pb: 0.375,
                            }}
                          >
                            {GroupIcon ? (
                              <Box
                                component="span"
                                sx={{
                                  display: "flex",
                                  flexShrink: 0,
                                  py: "2px",
                                  // Hides the guide line behind the icon.
                                  backgroundColor: designColors.white,
                                }}
                              >
                                <GroupIcon sx={{ fontSize: 16, color: NAV_COLORS.icon }} />
                              </Box>
                            ) : null}
                            <Typography
                              component="span"
                              sx={{
                                fontFamily: designFontFamily,
                                fontSize: 10.5,
                                fontWeight: designWeights.heading,
                                letterSpacing: "0.07em",
                                textTransform: "uppercase",
                                color: designColors.slate900,
                                lineHeight: 1.4,
                              }}
                            >
                              {nested.groupLabel}
                            </Typography>
                          </Box>
                        );
                      })()}
                      <ListItemButton
                        sx={{
                          ...panelRowSx({ page: nestedActive, depth: "nested" }),
                          // Rows under a group heading sit 8px further in than
                          // the heading text, so each group hangs under its label.
                          ...(nested.groupLabel ? { minHeight: 32, pl: "24px" } : {}),
                        }}
                        onClick={() => handleNestedNavigation(nested)}
                        aria-current={nestedActive ? "page" : undefined}
                      >
                        {rowLabel(
                          nested.displayName || nested.name,
                          {
                            ...panelTextSx({ page: nestedActive, depth: "nested" }),
                            ...(nested.groupLabel
                              ? {
                                  fontSize: 13.5,
                                  ...(nestedActive ? {} : { fontWeight: designWeights.regular }),
                                }
                              : {}),
                          },
                        )}
                      </ListItemButton>
                      {showDividerAfter && (
                        <Mui.Divider
                          sx={{
                            my: 0.5,
                            ml: 2,
                            mr: 2,
                            borderColor: designColors.slate100,
                          }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </List>
            </Collapse>
          </React.Fragment>
        );
      });
  };

  useEffect(() => {
    if (subMenuExpand) dispatch(setSubMenuExpand(false));
  }, [dispatch, subMenuExpand]);

  const handleClick = (event) => {
    setNotificationPanelOpen(false);
    setOpenSidePeek(true);
    setUpdateProfileSidePeek(true);
  };

  const handleNotificationOpenChange = (next) => {
    if (next) {
      setOpenSidePeek(false);
    }
    setNotificationPanelOpen(next);
  };

  const changeCompany = (event, data) => {
    if (data && String(data.company_id) !== String(topbarCompanyId)) {
      setOpenSidePeek(false);
      setNotificationPanelOpen(false);
      // The company-dependent effect loads products first; the route effect
      // then provisions the permitted destination, rather than the old module.
      provisioningRequests.current.start();
      productRequests.current.start();
      dispatch(setTopbarCompanyName(data?.label));
      dispatch(setTopbarCompanyId(data?.company_id));
      hydratePayslipTemplate({ domain, companyId: data?.company_id, dispatch });
      localStorage.setItem("topbarCompanyName", data?.label);
      localStorage.setItem("topbarCompanyId", data?.company_id);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Drawer
          variant="permanent"
          open={open}
          // No width animation while dragging, or the edge lags the pointer.
          sx={
            resizingPanel
              ? { transition: "none", "& .MuiDrawer-paper": { transition: "none" } }
              : undefined
          }
        >
          {/* Company logo header across the rail and the panel. Open: the
              same logo/name header as before the Slack layout. Collapsed:
              a Slack-style workspace tile on the dark rail. */}
          <Mui.Grid
            container
            alignItems="center"
            sx={{
              // No side padding when collapsed: the rail is too narrow
              // for it plus the tile's ring, which got clipped on the left.
              px: open ? 1 : 0,
              height: APP_BAR_HEIGHT,
              minHeight: APP_BAR_HEIGHT,
              borderBottom: open
                ? `1px solid ${themes.sidebarDivider}`
                : `1px solid ${RAIL_COLORS.divider}`,
              overflow: "hidden",
              boxSizing: "border-box",
              // Collapsed, the corner is the top of the dark rail (Slack).
              ...(open ? {} : { backgroundColor: RAIL_COLORS.top }),
            }}
          >
            {!open ? (
              <Mui.Grid
                item
                xs={12}
                sx={{
                  height: APP_BAR_HEIGHT,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "visible",
                }}
              >
                <Mui.Tooltip
                  title={
                    primaryCompany[0]?.companyname || userDetails?.firmName
                  }
                  placement="right"
                  arrow
                  slotProps={tooltipStyleProps}
                >
                  {/* Slack's workspace tile: rounded square with the
                      company's first letter, ringed in white. */}
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      backgroundColor: designColors.white,
                      boxShadow: `0 0 0 2px ${RAIL_COLORS.top}, 0 0 0 4px ${RAIL_COLORS.textActive}`,
                    }}
                  >
                    <Typography
                      component="span"
                      sx={{
                        fontFamily: designFontFamily,
                        fontSize: 20,
                        fontWeight: designWeights.heading,
                        lineHeight: 1,
                        color: RAIL_COLORS.top,
                      }}
                    >
                      {(
                        primaryCompany[0]?.companyname ||
                        userDetails?.firmName ||
                        "O"
                      )
                        .charAt(0)
                        .toUpperCase()}
                    </Typography>
                  </Box>
                </Mui.Tooltip>
              </Mui.Grid>
            ) : (
              <Mui.Grid
                item
                xs={12}
                sx={{
                  height: APP_BAR_HEIGHT,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {primaryCompany.length !== 0 &&
                primaryCompany[0]?.company_logo_url ? (
                  <Mui.Tooltip
                    title={primaryCompany[0].companyname}
                    slotProps={tooltipStyleProps}
                  >
                    <div
                      style={{
                        height: APP_BAR_HEIGHT,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={primaryCompany[0].company_logo_url}
                        alt={primaryCompany[0].companyname || "Company Logo"}
                        style={{
                          display: "block",
                          width: "auto",
                          height: "auto",
                          // Bigger than the old 160x48: the header now spans
                          // the rail and the panel (~300px wide).
                          maxWidth: "100%",
                          maxHeight: APP_BAR_HEIGHT - 8,
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </Mui.Tooltip>
                ) : (
                  <Mui.Tooltip
                    title={
                      primaryCompany[0]?.companyname || userDetails?.firmName
                    }
                    slotProps={tooltipStyleProps}
                  >
                    <span
                      style={{
                        display: "block",
                        maxWidth: "100%",
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: themes.headLine,
                        lineHeight: 1.2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {primaryCompany[0]?.companyname ||
                        userDetails?.firmName ||
                        "N/A"}
                    </span>
                  </Mui.Tooltip>
                )}
              </Mui.Grid>
            )}
          </Mui.Grid>
          <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
            {/* Product rail */}
            <Box
              sx={{
                width: SIDEBAR_RAIL_WIDTH,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                background: RAIL_COLORS.background,
              }}
            >
              <Box
                component="nav"
                aria-label="Products"
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  ...slackScrollbarSx(RAIL_COLORS.scrollThumb, RAIL_COLORS.scrollThumbHover),
                  // No reserved scrollbar space: it took 8px off each side
                  // and squeezed the white tile so labels ("My Work") were
                  // cut. The rail only scrolls on very short screens.
                  py: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.25,
                }}
              >
                {renderRail()}
              </Box>
            </Box>
            {/* Section panel (the menu button shows/hides it) */}
            {open && (
              <Box
                sx={{
                  position: "relative",
                  width: SIDEBAR_PANEL_WIDTH_VAR,
                  flexShrink: 0,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: designColors.white,
                }}
              >
                {showPayrollSettingsMenu && (
                  <Mui.ButtonBase
                    // Same place as the "Payroll" breadcrumb and the Payroll
                    // tile: Payroll's home (Salary > Salary Components). The
                    // page change switches the menu back to Payroll's rows.
                    onClick={() => {
                      setPayrollSettingsMenu(false);
                      dispatch(setCurrentScreen("Salary Configuration"));
                      localStorage.setItem("currentSubMenu", "Salary Configuration");
                      history.push(PAYROLL_HOME_PATH);
                    }}
                    aria-label="Back to Payroll"
                    sx={{
                      alignSelf: "flex-start",
                      mx: 1,
                      mt: 1.25,
                      mb: -0.75,
                      px: 0.75,
                      py: 0.25,
                      gap: 0.25,
                      borderRadius: "6px",
                      fontFamily: designFontFamily,
                      fontSize: 12.5,
                      fontWeight: designWeights.semibold,
                      color: designColors.tealDark,
                      "&:hover": { backgroundColor: designColors.tealTint },
                      "&.Mui-focusVisible": {
                        outline: `2px solid ${designColors.teal}`,
                      },
                    }}
                  >
                    ‹ Payroll
                  </Mui.ButtonBase>
                )}
                {/* Selected module name */}
                <Typography
                  noWrap
                  sx={{
                    flexShrink: 0,
                    px: 1.75,
                    pt: 1.75,
                    pb: 0.75,
                    fontFamily: designFontFamily,
                    fontSize: 16,
                    fontWeight: designWeights.heading,
                    color: designColors.slate900,
                    lineHeight: 1.3,
                  }}
                >
                  {showPayrollSettingsMenu
                    ? "Payroll Settings"
                    : currentProduct
                      ? currentProduct.displayName || currentProduct.name
                      : ""}
                </Typography>
                <Box
                  component="nav"
                  aria-label="Sections"
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    ...slackScrollbarSx("rgba(15, 23, 42, 0.22)", "rgba(15, 23, 42, 0.4)"),
                    pt: 0.25,
                    pb: 1,
                  }}
                >
                  <List disablePadding>
                    {showPayrollSettingsMenu
                      ? renderPayrollSettingsSections()
                      : renderPanelSections()}
                  </List>
                </Box>
                {/* Drag handle on the panel's right edge (Slack style) */}
                <Mui.Tooltip
                  title={resizingPanel ? "" : "Drag to resize · Double-click to reset"}
                  placement="right"
                  enterDelay={600}
                  slotProps={tooltipStyleProps}
                >
                  <Box
                    role="separator"
                    aria-orientation="vertical"
                    aria-label="Resize sidebar"
                    aria-valuemin={SIDEBAR_PANEL_MIN_WIDTH}
                    aria-valuemax={SIDEBAR_PANEL_MAX_WIDTH}
                    tabIndex={0}
                    onPointerDown={startPanelResize}
                    onDoubleClick={resetPanelWidth}
                    onKeyDown={handlePanelResizeKey}
                    sx={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      right: 0,
                      width: 6,
                      zIndex: 1,
                      cursor: "ew-resize",
                      touchAction: "none",
                      outline: "none",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        width: 2,
                        backgroundColor: resizingPanel
                          ? designColors.teal
                          : "transparent",
                        transition: "background-color 0.15s ease",
                      },
                      "&:hover::after, &:focus-visible::after": {
                        backgroundColor: designColors.teal,
                      },
                    }}
                  />
                </Mui.Tooltip>
              </Box>
            )}
          </Box>
        </Drawer>
        <Mui.AppBar
          sx={{
            backgroundColor: themes.whiteColor,
            boxShadow: "none",
          }}
          position="fixed"
        >
          <Mui.Grid
            container
            alignItems="center"
            sx={{
              minHeight: APP_BAR_HEIGHT,
              height: APP_BAR_HEIGHT,
              boxSizing: "border-box",
              paddingLeft: 1,
              paddingTop: 0,
              paddingBottom: 0,
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              position: "sticky",
              zIndex: 10,
            }}
          >
            {/* Left: hamburger + search (takes the free width) */}
            <Mui.Grid
              xs
              sx={{
                minWidth: 0,
                paddingLeft: open ? drawerWidth : `${SIDEBAR_RAIL_WIDTH}px`,
              }}
            >
              <Mui.Stack
                direction="row"
                alignItems="center"
                sx={{ paddingLeft: 1, gap: 1 }}
              >
                <IconButton
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                >
                  <MenuIcon sx={{ color: themes.headLine }} />
                </IconButton>
                <GlobalSearch routes={routes} sidebarOpen={open} onOpen={openSearchResult} />
              </Mui.Stack>
            </Mui.Grid>

            {/* Right: company selector + bell */}
            <Mui.Grid
              xs="auto"
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
                pr: 2,
              }}
            >
              {/* With a single company there is nothing to switch, so the
                  top bar shows neither the selector nor the company name. */}
              {currentLocation !== "My Workspace" &&
                !isCompaniesScreen &&
                selectableCompanies.length > 1 && (
                  <Box
                    sx={{
                      // Wider while the warning icon shows, so the company
                      // name is not cut off.
                      minWidth: workspaceUnavailable ? 260 : 180,
                      maxWidth: 390,
                    }}
                  >
                    <CustomAutoComplete
                      open={companyPickerOpen}
                      onOpen={() => setCompanyPickerOpen(true)}
                      onClose={() => setCompanyPickerOpen(false)}
                      inputRef={companyPickerInputRef}
                      inputEndAdornment={
                        workspaceUnavailable ? (
                          <Mui.Tooltip title="This workspace isn't available for this company">
                            <WarningRoundedIcon
                              sx={{ fontSize: 20, color: "#F59E0B", mr: 0.5 }}
                            />
                          </Mui.Tooltip>
                        ) : null
                      }
                      renderOptionContent={(option, content) => {
                        const isCurrent =
                          String(option.company_id) === String(topbarCompanyId);
                        return (
                          <Mui.Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{ width: "100%", minWidth: 0 }}
                          >
                            <CheckRoundedIcon
                              sx={{
                                fontSize: 18,
                                flexShrink: 0,
                                color: designColors.tealDark,
                                visibility: isCurrent ? "visible" : "hidden",
                              }}
                            />
                            <Box
                              component="span"
                              sx={{
                                flex: 1,
                                minWidth: 0,
                                fontWeight: isCurrent ? 600 : 400,
                              }}
                            >
                              {content}
                            </Box>
                            {isCurrent && workspaceUnavailable && (
                              <WarningRoundedIcon
                                sx={{ fontSize: 18, flexShrink: 0, color: "#F59E0B" }}
                              />
                            )}
                          </Mui.Stack>
                        );
                      }}
                      dataList={selectableCompanies
                        .map((obj) => ({
                          ...obj,
                          label: obj.company_name,
                        }))}
                      selectedValue={topbarCompanyName}
                      updateDataFunction={changeCompany}
                      placeHolder="Select the company"
                      sx={
                        isDesignSystemLocation
                          ? {
                              fontFamily: designFontFamily,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: designRadii.select,
                                fontFamily: designFontFamily,
                                fontSize: 13,
                              },
                              "& fieldset": {
                                borderColor: designColors.borderInput,
                              },
                              "&:hover fieldset": {
                                borderColor: designColors.borderInputHover,
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: designColors.teal,
                              },
                            }
                          : undefined
                      }
                    />
                  </Box>
                )}
              <NotificationBell
                open={notificationPanelOpen}
                onOpenChange={handleNotificationOpenChange}
              />
              <Box
                onClick={handleClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  cursor: "pointer",
                  ml: 1,
                }}
                aria-haspopup="true"
              >
                <Mui.Avatar
                  sx={{ width: 32, height: 32, bgcolor: "purple" }}
                  alt={firstLetter}
                  src={userDetails?.image_url}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: themes.headLine,
                    fontWeight: 500,
                    display: { xs: "none", md: "block" },
                    fontFamily: isDesignSystemLocation
                      ? designFontFamily
                      : "inherit",
                  }}
                >
                  {userDetails?.first_name}
                </Typography>
                <ArrowDropDownIcon
                  sx={{ color: themes.headLine, fontSize: 20 }}
                />
              </Box>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.AppBar>
        <Mui.Divider />
        <Mui.Grid sx={{ height: APP_BAR_HEIGHT }}></Mui.Grid>
        {/* flexGrow + minWidth 0 (MUI's standard drawer layout): the page
            fills the space beside the sidebar and is never widened by its
            content, so wide tables can scroll inside their own card. */}
        <Box component="main" sx={{ flexGrow: 1, minWidth: 0 }}>
          {currentRoute.component}
        </Box>
      </Box>
      <UserSidePeek
        openSidePeek={openSidePeek}
        setOpenSidePeek={setOpenSidePeek}
        firstLetter={firstLetter}
        userDetails={userDetails}
        setUpdateProfileSidePeek={setUpdateProfileSidePeek}
        updateProfileSidePeek={updateProfileSidePeek}
      />
    </>
  );
};
